import React from "react";
import { useGlobalLoading } from "../../../../shared/hooks/useGlobalLoading";
import { FlexColumn, FlexRow } from "../../../../components/Layout/Flex";
import FilterInputSearch from "../../../../components/Filter/FilterInputSearch";
import Button from "@mostrans/web-components/components/base/Button";
import { useGetEmployeeDemographyAdminWithFilter } from "../../../../GQL/Demography/hooks/useGetEmployeeDemographyAdminWithFilter";

export default function HeaderFilterDemography() {
  const [loading, , wrapWithLoading] = useGlobalLoading();
  const { refetch } = useGetEmployeeDemographyAdminWithFilter();

  return (
    <>
      <FlexColumn
        flexDirection="column"
        p="1rem"
        justifyContent="stretch"
        gap="1rem"
        borderBottom="1px solid var(--color-outlineSoft)">
        <FlexRow gap="1rem">
          <div className="d-flex flex-grow-1 w-100">
            <FilterInputSearch
              resetOnMount
              placeholder="Search Demography Content"
              containerProps={{ className: "w-100" }}
            />
          </div>
          <div>
            <Button
              onClick={() => loading || wrapWithLoading(() => refetch())}
              variant="contained"
              color="primary">
              Refresh
            </Button>
          </div>
        </FlexRow>
      </FlexColumn>
    </>
  );
}
